import { memo } from 'react';
import { useGrapesEditor } from '../../hooks/use-grapes-editor';
import { useEditorStore } from '../../stores/editor-store';
import { useMeasurement } from '../../hooks/use-measurement';

export const GrapesEditor = memo(function GrapesEditor() {
  const { containerRef, loading } = useGrapesEditor();
  const editor = useEditorStore((s) => s.editorInstance);
  const previewContent = useEditorStore((s) => s.previewContent);

  useMeasurement(editor);

  return (
    <div className="flex-1 overflow-hidden relative group">
      {loading && (
        <div className="absolute inset-0 z-40 flex items-center justify-center bg-surface">
          <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-accent"></div>
        </div>
      )}
      <div ref={containerRef} className="h-full w-full" />
      {previewContent && (
        <div className="absolute inset-0 z-50 bg-white pointer-events-none">
          <iframe
            className="w-full h-full border-0"
            srcDoc={`<!DOCTYPE html><html><head><script src="/tailwind.js"></script><style>${previewContent.css}</style></head><body>${previewContent.html}</body></html>`}
          />
        </div>
      )}
    </div>
  );
});
